var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 62,
    viewBox: "0 0 70 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.36 23.8499V26.8666C31.36 27.8247 31.5514 28.6285 31.929 29.2548C32.4499 30.119 33.305 30.6143 34.276 30.6143C35.2272 30.6143 36.1725 30.1511 37.0853 29.2383L47.0489 19.2746C49.2366 17.0869 49.2366 13.5274 47.0489 11.3397L37.0853 1.37604C36.1725 0.462799 35.2272 0 34.276 0C32.8244 0 31.36 1.15906 31.36 3.74771V6.48743C17.2142 7.32285 5.50369 18.1787 3.76327 32.3918C3.66576 33.1856 4.11712 33.9455 4.86099 34.2398C5.07156 34.3231 5.29083 34.3634 5.50735 34.3634C6.05575 34.3634 6.58767 34.1066 6.92642 33.6438C11.5947 27.2653 19.0901 23.4572 26.9765 23.4572C28.4376 23.4572 29.9071 23.589 31.36 23.8499Z",
    fill: "#5AB43A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1079 25.7602C54.364 25.4654 53.5153 25.7108 53.0424 26.3567C48.3746 32.7347 40.8792 36.5428 32.9928 36.5428C31.5317 36.5428 30.0622 36.411 28.6093 36.1501V33.1334C28.6093 30.5447 27.1445 29.3857 25.6933 29.3857C24.7421 29.3857 23.7968 29.8489 22.8836 30.7622L12.9199 40.7254C10.7327 42.9131 10.7327 46.4726 12.9204 48.6607L22.8836 58.624C23.7968 59.5372 24.7421 60 25.6933 60C27.1445 60 28.6093 58.841 28.6093 56.2523V53.5126C42.7556 52.6772 54.4656 41.8213 56.206 27.6087C56.3035 26.8144 55.8522 26.0545 55.1079 25.7602Z",
    fill: "#BDE1B0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 46,
    r: 16,
    fill: "#FF5200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5599 39.6799C49.0403 39.1606 48.1997 39.1604 47.6801 39.6799C47.1604 40.1995 47.1604 41.0405 47.6801 41.5601L52.3436 46.2238L47.6801 50.8875L47.68 50.8876C47.1604 51.4071 47.1606 52.2481 47.6801 52.7676C47.9392 53.0268 48.2804 53.157 48.62 53.157C48.9598 53.157 49.3009 53.0266 49.56 52.7675L54.2236 48.1038L58.8874 52.7675C59.1465 53.0266 59.4876 53.157 59.8274 53.157C60.1672 53.157 60.5083 53.0266 60.7674 52.7675C61.2871 52.248 61.287 51.407 60.7673 50.8875L56.1037 46.2238L60.7673 41.5601C61.2871 41.0405 61.2871 40.1996 60.7674 39.68C60.2478 39.1605 59.4069 39.1605 58.8874 39.68L54.2236 44.3438L49.5599 39.6799Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeFailedIcon);
export default __webpack_public_path__ + "static/media/exchangeFailedIcon.0d46791564198c0c3f590b8f11885232.svg";
export { ForwardRef as ReactComponent };